const BEELAJAR_BASE_URL_LOGIN = process.env.REACT_APP_BEELAJAR_URL;

export const beelajarServices = {
  BEELAJAR: {
    LOGIN: `${BEELAJAR_BASE_URL_LOGIN}`
  }
};
